export const CBottomFooterLinks = {
  field: `
      fragment bottomFooterLinks on bottomFooterLinks_MatrixField {
        ... on bottomFooterLinks_links_Entry {
          id
          linkName
          linkUrl
          linkPosition
        }
      }
    `,
}
